import { render, staticRenderFns } from "./taskdetail.vue?vue&type=template&id=0ecb7414"
import script from "./taskdetail.vue?vue&type=script&lang=js"
export * from "./taskdetail.vue?vue&type=script&lang=js"
import style0 from "./taskdetail.vue?vue&type=style&index=0&id=0ecb7414&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports